import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { useNavigate } from "react-router-dom";
import "../../Styles/style.css";
import AdminApiModule from "../../components/AdminApi/Api/api";
import ViewFeedBackPOpup from "../../components/Components/ViewFeedBackPopup";
import { Button } from "@mui/material";

const options = {
  filterType: "dropdown",
};

const Centers = () => {
  const navigate = useNavigate();
  const [feedBackList, setFeedBackList] = useState([]);
  const [viewfeedback, setViewFeedback] = useState([]);
  const [isOpenFeedBackPopup, setIsOpenFeedBackPopup] = useState(false);

  const columns = [
    {
      name: "center_id",
      label: "Center Id",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "center_name",
      label: "Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "qrStatus",
      label: "Qr Status",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "ticket_id",
      label: "ticket id",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "technicianName",
      label: "Technician Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "technicianPhone",
      label: "Technician Phone",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "customer_name",
      label: "customer_name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "customer_number",
      label: "customer_number",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Address",
      label: "Address",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "FeedBack",
      label: "FeedBack",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "is_aldready_submitted",
      label: "is FeedBack submitted",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "over_all_rating",
      label: "Over all rating",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "viewfeedback",
      label: "view feedback",
      options: {
        customBodyRender: (value) => {
          return (
            <Button
              className="text-transform-none"
              variant="contained"
              onClick={() => toggleOpenFeedBackPopup(value)}
            >
              View Feedback
            </Button>
          );
        },
      },
    },
    {
      name: "View_ticket",
      label: "view Ticket",
      options: {
        customBodyRender: (value) => {
          return (
            <Button variant="contained" onClick={() => handleViewTicket(value)}>
              View Ticket
            </Button>
          );
        },
      },
    },
  ];

  const handleViewTicket = (id) => {
    navigate("/view-ticket?ticketId=" + id);
  };

  const toggleOpenFeedBackPopup = (feedback) => {
    setViewFeedback(feedback);
    setIsOpenFeedBackPopup(true);
  };

  const toggleCloseFeedBackPopup = () => {
    setIsOpenFeedBackPopup(false);
    setViewFeedback([]);
  };

  const getFormattedServices = (services) => {
    let secondary_services_list = [];
    services?.forEach((item) => {
      if (item.secondary_services_id?.service_name) {
        secondary_services_list.push(item.secondary_services_id.service_name);
      }
    });
    return secondary_services_list.join(", ");
  };

  const getParsedData = (data) => {
    return (
      data?.map((item) => ({
        center_id: item.center_obj_id?.qr_details?.qr_id,
        qrStatus: item.center_obj_id?.qr_details?.qrStatus,
        center_name: item.center_obj_id?.center_name,
        ticket_id: item?.ticket_obj_id?._id,
        technicianName:
          item?.ticket_obj_id?.assigned_ids?.assigned_technician_id
            ?.personal_details?.name,
        technicianPhone:
          item?.ticket_obj_id?.assigned_ids?.assigned_technician_id
            ?.personal_details?.phone?.mobile_number,
        Address: [
          item?.ticket_obj_id?.address_details?.city,
          item?.ticket_obj_id?.address_details?.state,
          item?.ticket_obj_id?.address_details?.country,
        ]
          .filter(Boolean)
          .join(" "),
        customer_name: item?.ticket_obj_id?.personal_details?.name,
        customer_number:
          item?.ticket_obj_id?.personal_details?.alternate_phone?.mobile_number,
        FeedBack: JSON.stringify(item?.feedBackResponse),
        viewfeedback: item?.feedBackResponse,
        over_all_rating: item?.over_all_rating,
        is_aldready_submitted: item?.is_already_submitted ? "Yes" : "No",
        View_ticket: item?.ticket_obj_id?._id,
      })) || []
    );
  };

  const getAllFeedBack = () => {
    new AdminApiModule()
      .getAllFeedBack()
      .then((res) => {
        setFeedBackList(getParsedData(res?.data));
      })
      .catch(console.error);
  };

  useEffect(() => {
    getAllFeedBack();
  }, []);

  return (
    <div>
      <MUIDataTable
        title={"FeedBackList"}
        data={feedBackList}
        columns={columns}
        options={options}
      />

      <ViewFeedBackPOpup
        open={isOpenFeedBackPopup}
        handleClose={toggleCloseFeedBackPopup}
        viewfeedback={viewfeedback}
      />
    </div>
  );
};

export default Centers;
